import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { Center, Container } from '@mantine/core';
import { isAuthenticatedSync } from '@/shared/lib/auth-state';

export const Route = createFileRoute('/_auth')({
  beforeLoad: () => {
    if (isAuthenticatedSync()) {
      throw redirect({ to: '/' });
    }
  },
  component: AuthLayout,
});

function AuthLayout() {
  return (
    <Center mih="100vh">
      <Container size="xs" w="100%" py="xl">
        <Outlet />
      </Container>
    </Center>
  );
}
